import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { urlWithQuery } from '~/utils/url';
import type { CompanyInvoiceDto, CompanyInvoicePaginationDto, PayCompanyInvoiceDto } from '~/swagger/portal/Api';

export type GetInvoicesParams = {
  page?: number;
  pageSize?: number;
  from?: string;
  to?: string;
};

export class CompanyInvoicesRepository extends BaseRestRepository {
  private readonly BASE_URL = '/api/invoices';

  getInvoices = async (params?: GetInvoicesParams): Promise<CompanyInvoicePaginationDto> => {
    const url = this.BASE_URL;
    const response = await this.fetchWithAuth(urlWithQuery(url, params));
    return this.getJsonResponse(response);
  };

  getInvoice = async (billId: string): Promise<CompanyInvoiceDto> => {
    const url = this.BASE_URL + '/' + billId;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  };

  payInvoice = async ({
    billId,
    paymentAccountId,
    paymentMethodId,
  }: { billId: string } & PayCompanyInvoiceDto): Promise<CompanyInvoiceDto> => {
    const body: PayCompanyInvoiceDto = {};
    if (paymentAccountId) body.paymentAccountId = paymentAccountId;
    if (paymentMethodId) body.paymentMethodId = paymentMethodId;
    const url = this.BASE_URL + '/' + billId + '/pay';
    const response = await this.fetchWithAuth(url, { method: 'POST', body: JSON.stringify(body) });
    return this.getJsonResponse(response);
  };
}

export const companyInvoicesRepository = new CompanyInvoicesRepository();
